<template>
  <div class="sheets">
    <button class="print-button pure-button" @click="print">印刷</button>
    <section v-for="(data, index) in transportData" :key="data.index" class="sheet">
      <h2 class="title">交通費精算書</h2>
      <div class="date">
        <span class="ym">{{ ym }}</span>
      </div>
      <div class="property">
        <span class="attribute">所属：{{ data[0].Attribute1 }}</span><span class="name">氏名：{{ data[0].UserName }}</span>
      </div>
      <table>
        <thead>
          <tr>
            <td class="td-date">日付</td>
            <td class="td-from">出発地</td>
            <td class="td-to">到着地</td>
            <td class="td-parking">駐車場</td>
            <td class="td-fee">交通費</td>
            <td class="td-fee">お客様請求</td>
            <td class="td-meany-type">交通手段</td>
            <td class="td-matter">用件</td>
            <td class="td-receipt">領収書</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="transport in data" :key="transport.id">
            <td class="td-date">{{ transport.Ymd }}</td>
            <td class="td-from">{{ transport.FromStation }}</td>
            <td class="td-to">{{ transport.ToStation }}</td>
            <td class="td-parking">{{ transport.Parking }}</td>
            <td class="fee td-fee">{{ transport.TransportFee.toLocaleString() }} 円</td>
            <td class="fee td-fee">{{ transport.ChargeToCustomerFee.toLocaleString() }} 円</td>
            <td class="td-meany-type">{{ meanyType(transport.MeanyType) }}</td>
            <td class="td-matter">
              <span class="matter">{{ transport.Matter }}</span>
            </td>
            <td class="td-receipt">
              <span v-if="transport.ImageEntry != 0">●</span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="td-tfoot" colspan="9">
              <span>交通費合計：</span><span class="total-fee">{{ totalFee(index , 'TransportFee') }}</span><span> 円　　</span>
              <span>お客様請求合計：</span><span class="total-fee">{{ totalFee(index, 'ChargeToCustomerFee') }}</span><span> 円　　</span>
              <span>金額合計：</span><span class="total-fee">{{ totalFee(index, 'FeeTotal') }}</span><span> 円</span>
            </td>
          </tr>
        </tfoot>
      </table>
    </section>
  </div>
</template>

<script>
import moment from "moment"

export default {
  data() {
    return {
      transportData: {}
    }
  },

  created() {
    this.getTransportData()
  },

  computed: {
    ym() {
      return moment(this.$route.query.month, 'YYYY年M月D日').format('YYYY年M月')
    },

    meanyType() {
      return function(type) {
        switch (type) {
          case 0:
            return "電車"
          case 1:
            return "バス"
          case 2:
            return "タクシー"
          default:
            return "駐車場"
        }
      }
    },

    totalFee() {
      return function(index, type) {
        return this.transportData[index]
                    .reduce((current, next) => current + Number(next[type]), 0)
                    .toLocaleString()
      }
    }
  },

  methods: {
    getTransportData() {
      let users = this.$route.query.users
      let userIds = Array.isArray(users) ? users : [users]

      this.$http.get("/transport_detail_print_data", {
        params: {
          month: this.$route.query.month,
          sortState: this.$route.query.sortState,
          userIds: userIds
        }
      })
      .then((res) => {
        this.transportData = res.data.transports
      })
    },

    print() {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
.print-button {
  margin: 20px 30px 0 auto;
  display: block;
  background: linear-gradient(135deg, #fff5ee, #83ccd2);
}

.title {
  text-align: center;
}

.property {
  margin-bottom: 15px;
  text-align: end;
}

.attribute {
  margin-right: 25px;
}

table {
  width: 99%;
  font-size: 10pt;

  tr {
    min-height: 30px;
    display: table-row;
    page-break-inside: avoid;
  }

  td {
    padding: 3px;
    border: 1px solid black;
  }

  thead, tfoot {
    background-color: #e0e0e0;
  }

  thead {
    display: table-header-group;
  }

  tbody {
    overflow-y: hidden;
    display: table-row-group;
  }

  tfoot {
    display: table-row-group;;
  }
}

.td-date {
  width: 70px;
}

.td-from, .td-to {
  width: 90px;
}

.td-parking {
  width: 90px;
}

.td-fee {
  width: 80px;
}

.td-meany-type {
  width: 100px;
}

.td-matter {
  width: 100px;
}

.td-receipt {
  width: 50px;
}

.tr-tfoot {
  display: table;
}

.td-tfoot {
  text-align: end;
}

.fee {
  text-align: right;
}

/* hide in print */
@media print {
  .print-button {
    display: none;
  }

  .sheet {
    page-break-after: always;
  }
}

/* for preview */
@media screen {
  .sheet {
    width: 200mm; // A4
    min-height: 296mm; // A4
    margin: 5px auto;
    padding: 5mm;
    background: white;
    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3);
  }
}
</style>

<style lang="scss">
#app {
  overflow-y: initial !important;
}

footer {
  display: none;
}

/* for preview */
@media screen {
  body {  
    background: #eee;
  }
}

@media print {
  body {
    height: auto;
  }
}
</style>